import useSWR from "swr";

export const useCategoryItemType = (searchQuery) => {
    const clientsKey = searchQuery ? `/production-category-item-type/search-category-item-type?searchParams=${searchQuery}` : `/production-category-item-type`;
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        category_item_type: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};